export var getPinterestShareUrl = _ref => {
  var {
    description = document.title,
    url = document.location.href,
    image
  } = _ref;
  var parameters = {
    description: encodeURIComponent(description),
    media: image ? encodeURIComponent(image) : undefined,
    url: encodeURIComponent(url)
  };
  var parametersString = Object.entries(parameters).map(entry => entry.join('=')).join('&');
  return "https://pinterest.com/pin/create/button/?".concat(parametersString);
};